import React from 'react'

export const BoxHeader = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>((props, ref) => {
  const { className, ...rest } = props
  return <div ref={ref} className={`px-8 py-4 ${className}`} {...rest}>
    {props.children}
  </div>
})